import React from 'react';
import { connect } from 'react-redux';

import Page from '../../../page.jsx';
import ReceiptLink from '../../../receiptLink.jsx';
import { data as paymentDataPropTypes } from '../../../paymentPropTypes.js';
import partnerPropTypes from '../../../partnerPropTypes.js';
import withdrawalPropTypes from '../../../withdrawalPropTypes.js';
import formatOreToKroner from '../../../../lib/formatOreToKroner.js';
import ReviewLink from '../../../review/reviewLink.jsx';
import FeedbackLink, { SELLER_SAD } from '../../../feedbackLink.jsx';

const DiscountApprovedWithAutomaticWithdrawalDetails = ({
    partner,
    payment,
}) => (
    <div>
        <p>
            Du har fått {formatOreToKroner(payment.amount)} for varen, og{' '}
            {formatOreToKroner(payment.freight)} for frakt. Du vil se pengene på
            konto mellom 1&ndash;3 virkedager etter avslaget ble gitt.
        </p>

        <div className="r-phl r-ptl">
            <ReceiptLink payment={payment} />
            <ReviewLink partner={partner} />
            <FeedbackLink type={SELLER_SAD} />
        </div>
    </div>
);

DiscountApprovedWithAutomaticWithdrawalDetails.propTypes = {
    partner: partnerPropTypes.isRequired,
    payment: paymentDataPropTypes.isRequired,
};

const DiscountApprovedWithoutAutomaticWithdrawalDetails = ({ payment }) => (
    <div>
        <p>
            Du har fått {formatOreToKroner(payment.amount)} for varen, og{' '}
            {formatOreToKroner(payment.freight)} for frakt på din{' '}
            <a href={payment.spidWalletUrl}>SPiD Cash-konto</a>.
        </p>

        <div className="r-phl r-ptl">
            <a
                href={payment.withdrawFlowSpidUrl}
                className="button r-mbl primary fullwidth"
            >
                Overfør pengene til din bankkonto
            </a>

            <ReceiptLink payment={payment} />
            <FeedbackLink type={SELLER_SAD} />
        </div>
    </div>
);

DiscountApprovedWithoutAutomaticWithdrawalDetails.propTypes = {
    payment: paymentDataPropTypes.isRequired,
};

const DiscountApprovedDetails = ({ partner, payment, withdrawal }) => (
    <Page heading="Dere har blitt enige om et prisavslag, og handelen er ferdig">
        <p>
            {partner.name} fikk et prisavslag på{' '}
            {formatOreToKroner(payment.discount)}.
        </p>

        {withdrawal ? (
            <DiscountApprovedWithAutomaticWithdrawalDetails
                partner={partner}
                payment={payment}
            />
        ) : (
            <DiscountApprovedWithoutAutomaticWithdrawalDetails
                partner={partner}
                payment={payment}
            />
        )}
    </Page>
);

DiscountApprovedDetails.propTypes = {
    partner: partnerPropTypes.isRequired,
    payment: paymentDataPropTypes.isRequired,
    withdrawal: withdrawalPropTypes,
};

function mapStateToProps(state) {
    return {
        partner: state.partner,
        payment: state.payment.data,
        withdrawal: state.withdrawal,
    };
}

export default connect(mapStateToProps)(DiscountApprovedDetails);



// WEBPACK FOOTER //
// ./safeTrade/seller/resolution/statusDetails/discountApprovedDetails.jsx